<template>
  <v-inventory-create
    v-if="access.create_mark"
    name="purchase"
    ref="purchase"
    top_title="create_purchase_mark"
    :noAdditionalCost="true"
  >
    <v-layout row class="px-2">
      <v-flex class="px-1">
        <v-autocomplete
          v-model="params.supplier_id"
          :label="$t('supplier')"
          v-bind:items="suppliers"
          item-value="_id"
          item-text="supplier_name"
          ref="supplier"
          :rules="[fieldRules.required]"
        />
      </v-flex>
      <v-flex class="px-1">
        <v-autocomplete
          v-model="params.service"
          :label="$t('store')"
          v-bind:items="stores"
          item-text="name"
          item-value="_id"
          ref="service"
          :rules="[fieldRules.required]"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex class="px-1" md6 sm12>
        <v-datetime-picker
          v-model="params.purchase_order_date"
          :label="$t('purchase_order_date')"
        />
      </v-flex>
      <v-flex class="px-1" md6 sm12>
        <v-datetime-picker
          v-if="params.type == 'coming'"
          v-model="params.expected_on"
          :label="$t('expected_on')"
          v-bind:min="params.purchase_order_date"
        />
      </v-flex>
    </v-layout>

    <template #add_items_by_supplier>
      <v-menu left>
        <template #activator="{ on, attrs }">
          <v-btn color="primary" dark v-bind="attrs" v-on="on" text>
            AutoFill
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list :disabled="params.supplier_id == null">
          <v-list-item
            @click="addBySupplier(1)"
            :disabled="params.supplier_id == null"
          >
            <v-list-item-title>{{
              $t("all_items_from_the_supplier")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="addBySupplier(2)"
            :disabled="params.supplier_id == null"
          >
            <v-list-item-title>{{
              $t("low_stock_items_from_the_supplier")
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <br />
    <template #items>
      <v-data-table
        v-bind:headers="headers"
        disable-sort
        v-bind:items="items"
        :items-per-page="200000"
        hide-default-footer
        :mobile-breakpoint="0"
        :no-data-text="$t('you_have_not_selected_items_yet')"
      >
        <template #[`item.product_name`]="{ item }">
          <v-list-item-content
            style="
              width: 350px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            <v-list-item-title>{{ item.product_name }}</v-list-item-title>
            <v-list-item-subtitle>SKU {{ item.sku }}</v-list-item-subtitle>
            <v-list-item-subtitle
              v-if="item.barcode && item.barcode.length > 0"
            >
              Barcode
              <span v-for="(barcode, ind) in item.barcode" :key="ind">{{
                barcode + ", "
              }}</span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <template #[`item.quality`]="{ item }">
          <v-text-field
            v-model.number="item.quality"
            type="number"
            :ref="'quality' + item._id"
            :rules="[fieldRules.require]"
            @focus="$event.target.select()"
          />
        </template>
        <template #[`item.purchase_cost`]="{ item }">
          <vuetify-money
            v-model="item.purchase_cost"
            :ref="'purchase_cost' + item.product_id"
            :rules="[fieldRules.require]"
            v-bind:options="
              item.purchase_cost_currency == 'uzs'
                ? moneyOptions
                : moneyOptionsUSD
            "
          ></vuetify-money>
        </template>
        <template #[`item.amount`]="{ item }">{{
          item.quality * item.purchase_cost
            ? (item.quality * item.purchase_cost).toLocaleString()
            : "-"
        }}</template>
        <template #[`item.remove`]="{ item }">
          <v-btn icon v-on:click="remove_item(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <v-divider />
      <v-card-text>
        <v-search-items
          v-bind:label="$t('add_item')"
          v-bind:items="items_list"
          v-bind:selectedAct="add_item"
          v-bind:rules="items && items.length == 0 ? [fieldRules.required] : []"
          v-bind:searchItems="getPurchaseItems"
        ></v-search-items>
      </v-card-text>
    </template>

    <template #action>
      <v-btn v-on:click="cancel" text>{{ $t("cancel") }}</v-btn>
      <v-btn
        color="success"
        text
        v-on:click="save"
        :loading="saving_document"
        :disabled="saveDisabled"
        >{{ $t(target) }}</v-btn
      >
    </template>

    <v-dialog v-model="exist_dialog" persistent width="500">
      <v-card>
        <v-card-text class="pa-5 black--text">
          This item has already been added
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="exist_dialog = false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-inventory-create>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
import Currency from "../../mixins/settings/currency";
export default {
  name: "PurchaseCreate",
  mixins: [Services, Currency],
  data: () => ({
    items: [],
    items_list: [],
    item: null,
    suppliers: [],
    params: {
      type: "coming",
      supplier_id: null,
      purchase_order_date: new Date().toISOString().substr(0, 10),
      expected_on: new Date().toISOString().substr(0, 10),
      service: null,
      total_currency: "uzs",
      total: 0,
    },
    search_text: "123",
    noAllStores: true,
    noAllEmployes: true,
    exist_dialog: false,
    exist_item: null,
    access: null,
    items_file: null,
    receipt_id: "",
    receipts: [],
    upload_errors: [],
    saving_document: false,
  }),
  computed: {
    headers() {
      let headers = [
        { text: this.$t("item"), value: "product_name" },
        {
          text: this.$t("in_stock"),
          value: "in_stock",
          width: 90,
          align: "right",
        },
      ];
      headers.push({ text: null, value: "remove", align: "center", width: 50 });
      return headers;
    },
    target() {
      return this.$route.params["target"];
    },
    form() {
      const fObj = {
        supplier: this.params.supplier_id,
        service: this.params.service,
      };

      return fObj;
    },
    saveDisabled() {
      let formHasErrors = false || this.items.length == 0;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f] && this.form[f] != 0) {
          formHasErrors = true;
        }
      });
      return formHasErrors;
    },
  },
  watch: {
    "params.service"() {
      this.getPurchaseItems(this.search_text, true);
      this.itemsRefresh();
    },
    stores() {
      if (this.stores && this.stores.length > 0) {
        this.params.service = this.stores[0]._id;
      }
    },
  },
  methods: {
    add_item(item) {
      let exist = false;
      for (const itm of this.items) {
        if (itm.product_id == item.product_id) {
          exist = true;
        }
      }
      if (exist) {
        this.exist_dialog = true;
      } else {
        this.items.push(this.$copy(item));
      }
    },
    remove_item(item) {
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);
    },
    async update() {
      const suppliers = this.$communicator.then(
        this,
        await this.$communicator("all_suppliers")
      );
      if (suppliers) this.suppliers = suppliers;
      if (this.target == "update") {
        const purchase = this.$communicator.then(
          this,
          await this.$communicator("purchase", {
            arguments: [this.$route.query["id"]],
          })
        );
        for (let i = 0; i < purchase.additional_cost.length; i++) {
          purchase.additional_cost[i].index = i + 1;
        }
        this.$refs["purchase"].init(purchase);
        this.items = this.$copy(purchase.items);
        this.params.supplier_id = purchase.supplier_id;
        this.params.service = purchase.service;
        this.params.purchase_order_date = new Date(purchase.purchase_order_date)
          .toISOString()
          .substr(0, 10);
        if (purchase.expected_on) {
          this.params.expected_on = new Date(purchase.expected_on)
            .toISOString()
            .substr(0, 10);
        }
      }
      this.getPurchaseItems();
    },
    async getPurchaseItems(search, service_changed = false) {
      if (typeof search != typeof "invan") {
        search = "";
      }

      if (search == this.search_text && !service_changed && search != "123") {
        return;
      }

      this.search_text = search + "";
      const items = this.$communicator.then(
        this,
        await this.$communicator("list_of_inv_items", {
          arguments: [20, 1],
          params: {
            service: this.params.service,
            search: search,
          },
        })
      );
      if (items) {
        var items_list = [];

        for (const index in items) {
          let search_text =
            items[index].name +
            this.converter(items[index].name) +
            items[index].sku;
          if (
            items[index].barcode &&
            typeof items[index].barcode == typeof []
          ) {
            for (const b of items[index].barcode) {
              search_text += b;
            }
          }
          items_list.push({
            product_id: items[index]._id,
            amount: items[index].price,
            product_name: items[index].name,
            purchase_cost:
              typeof items[index].purchase_cost != typeof 5 ||
              !items[index].purchase_cost
                ? 0
                : items[index].purchase_cost,
            search_text: search_text,
            quality: items[index].quality,
            sku: items[index].sku,
            barcode: items[index].barcode,
            in_stock: items[index].in_stock,
            incoming: items[index].incoming,
            purchase_cost_currency: items[index].purchase_cost_currency,
          });
        }
        this.items_list = items_list;
      }
    },
    async itemsRefresh() {
      const item_ids = [];
      for (const it of this.items) {
        item_ids.push(it.product_id);
      }

      const response = this.$communicator.then(
        this,
        await this.$communicator("get_items_for_purchase_refresh", {
          params: {
            indexes: item_ids,
            service: this.params.service,
          },
        })
      );

      if (response instanceof Array) {
        const itemMap = {};
        for (const it of response) {
          itemMap[it._id] = it;
        }
        for (const ind in this.items) {
          if (itemMap[this.items[ind].product_id]) {
            this.items[ind].incoming =
              itemMap[this.items[ind].product_id].incoming;
            this.items[ind].in_stock =
              itemMap[this.items[ind].product_id].in_stock;
          }
        }
      }
    },
    async save() {
      this.saving_document = true;
      var params = this.$copy(
        Object.assign(this.params, this.$refs["purchase"].options())
      );
      params.purchase_order_date = new Date(
        params.purchase_order_date
      ).getTime();
      if (params.expected_on) {
        params.expected_on = new Date(params.expected_on).getTime();
      }
      var items = [];
      for (const index in this.items) {
        items.push({
          product_id: this.items[index].product_id,
          cost: this.items[index].cost,
          product_name: this.items[index].product_name,
          purchase_cost: this.items[index].purchase_cost,
          purchase_cost_currency: this.items[index].purchase_cost_currency,
          quality: this.items[index].quality,
          sku: this.items[index].sku,
        });
      }
      params.items = items;

      if (this.target == "create") {
        const response = this.$communicator.then(
          this,
          await this.$communicator("create_purchase_simple", {
            params: params,
          })
        );
        if (response) {
          this.$toast.success("Success", { timeout: 2000 });
          this.$router.push({
            path: "/inventory/purchase/view",
            query: {
              id: response._id,
            },
          });
        }
      }
      this.saving_document = false;
    },
    cancel() {
      if (this.target == "create") {
        // this.$router.push({ path: "/inventory/purchase" });
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: "/inventory/purchase/view",
          query: this.$route.query,
        });
      }
    },
    async addBySupplier(ind) {
      const items = this.$communicator.then(
        this,
        await this.$communicator("get_items_for_purchase", {
          params: {
            service: this.params.service,
            supplier: this.params.supplier_id,
            state: ind == 2 ? "low" : "all",
          },
        })
      );

      const existItems = {};
      for (const itm of this.items) {
        existItems[itm.product_id] = itm;
      }
      for (const item of items) {
        if (existItems[item._id] == undefined) {
          this.items.push({
            ...item,
            product_id: item._id,
            product_name: item.name,
          });
        }
      }
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
  mounted() {
    this.update();
  },
};
</script>
